import React from 'react';
import GlobalMenu from '@/components/global/menu/GlobalMenu';
import Withdraw from '@/components/contents/pay/Withdraw';
import { getLocaleWordContent } from '@/utils/language.util';

export default function PayPage() {
    return (
        <div id="wrap" className="main sub_page">
            <div className="inner">
                <GlobalMenu />
                <h2 className="text-center">{getLocaleWordContent('출금')}</h2>
            </div>
            <div className="withdraw">
                <Withdraw />
            </div>
        </div>
    );
}
